import {
  Card,
  Stack
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from 'src/components/ConfirmationDialog';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import Spinner from 'src/utils/Loader/spinner';
import { useToaster } from 'src/utils/toaster/toasterContext';
import NoPostFound from '../publishedPosts/noPost.component';
import CreateBrandToolbar from './createBrandToolbar';
import OrganizationBrandTable from './organization-brand-table';

const OrgManageBrand = () => {
  const { t: translate } = useTranslation();
  const [brandList, setBrandList] = useState([]);
  const [orgLimitationDetails, setOrgLimitationDetails] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const { showToast } = useToaster();
  const [toBeDeletedId, setToBeDeletedId] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [height, setHeight] = useState(window.innerHeight - 150);
  const activeBrandId = CommonHelper.GetCurrentBrandId();

  useEffect(() => {
    getAllBrands();
  }, []);

  const getAllBrands = () => {
    setLoader(true);
    let postProps = {
      url: userModuleURL.fetchUsersBrand,
      successCallback,
      failureCallback,
    };
    HttpServices.Get(postProps);
  };

  const successCallback = (data, message) => {
    setBrandList(data.users_brand);
    setOrgLimitationDetails(data.org_plan_limit_info);
    message && showToast(message, 's');
    setLoader(false);
  };

  const failureCallback = (message) => {
    message && showToast(message, 'e');
    setLoader(false);
  };

  const handleBrandStatus = (brand) => {
    let bodyProps = { brand_id: brand.brand_id };
    let postProps = {
      url: brand.is_enabled ? userModuleURL.disableBrand : userModuleURL.enableBrand,
      body: bodyProps,
      successCallback: successBrandStatusCallback,
      failureCallback: (message) => failureBrandStatusCallback(message, brand.brand_id),
    };

    let updatedBrandList = brandList.map((b) => {
      if (b.brand_id === brand.brand_id) {
        return { ...b, is_enabled: !b.is_enabled };
      }
      return b;
    });

    setBrandList(updatedBrandList);
    HttpServices.Post(postProps);
  };

  const successBrandStatusCallback = (data, message) => {
    showToast(message, 's');
  };

  const failureBrandStatusCallback = (message, brandId) => {
    setBrandList((prevBrandList) =>
      prevBrandList.map((b) => {
        if (b.brand_id === brandId) {
          return { ...b, is_enabled: !b.is_enabled };
        }
        return b;
      })
    );

    showToast(message, 'e');
  };

  const handleDelete = (id) => {
    setToBeDeletedId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = () => {
    setConfirmOpen(false);
    let brandprops = { brand_id: toBeDeletedId };
    let postProps = {
      url: userModuleURL.deleteBrand,
      body: brandprops,
      successCallback: updateSuccessCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };
  const updateSuccessCallback = (data, message) => {
    if (activeBrandId === toBeDeletedId) {
      window.location.reload();
    } else {
      getAllBrands();
    }
    showToast(message, 's');
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleRefreshGrid = () => {
    getAllBrands();
  };
  return (
    <>
      <Helmet>
        <title>{translate('navbar.menu.manage_brand')}</title>
      </Helmet>
      {loader ? (
        <Spinner />
      ) : (
        <>
          <Stack direction="row" justifyContent="flex-end" alignItems="center">
            <CreateBrandToolbar handleRefreshGrid={handleRefreshGrid} />
          </Stack>

          {brandList && brandList.length > 0 ? (
            <Card sx={{ m: 1 }}>
              <OrganizationBrandTable
                brandList={brandList}
                rowsPerPage={rowsPerPage}
                page={page}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleBrandStatus={handleBrandStatus}
                handleDelete={handleDelete}
                getAllBrands={getAllBrands}
              />
            </Card>
          ) : (
            <Card>
              <NoPostFound height={height} />
            </Card>
          )}
        </>
      )}
      <ConfirmationDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={confirmDelete}
        title={translate('common.confirm_deletion')}
        message={`${translate('common.confirm_delete_brand')}?`}
      />
    </>
  );
};

export default OrgManageBrand;
